import { debounce } from '@utils/debounce';

// This function is used to add gradient classes to the table container based on the scroll position of the table.
// It adds a gradient effect to the left and right sides of the table when it is scrolled.
// It makes it easier for mobile users to see that there is more content to scroll to.
export const useTable = (tableContainer: HTMLElement, tableScrollContainer: HTMLElement, tableElement: HTMLElement)=>  {
  const updateTableGradients = () => {
    const isScrolledToRight = tableScrollContainer.scrollLeft + tableScrollContainer.clientWidth + 10 >= tableElement.scrollWidth;
    const isScrolledToLeft = tableScrollContainer.scrollLeft === 0;

    tableContainer.classList.toggle("table-container--gradient-active-right", !isScrolledToRight);
    tableContainer.classList.toggle("table-container--gradient-active-left", !isScrolledToLeft);
  };

  const initTableGradient = (eventsAlreadyInitialized = false) => {
    // If resize event is already initialized, do not add it again
    if (!eventsAlreadyInitialized) {
      // Add gradient classes when the table is resized
      window.addEventListener("resize", debounce(updateTableGradients, 250));
    }

    // Add gradient classes when the table is scrolled
    tableScrollContainer.addEventListener("scroll", debounce(updateTableGradients, 100));
    
    // Initial call
    updateTableGradients();
  };

  return { initTableGradient };
}